import MapChart from './mapChart.js';
export default MapChart;
